// src/pages/ClientPanel/Products/filterproduct/index.tsx

// Esta linha diz: "Importe o componente ProductsFilterModal que está no arquivo ProductsFilterModal.tsx, aqui na mesma pasta."
import ProductsFilterModal from './ProductsFilterModal';

// Esta linha diz: "Quando alguém importar esta pasta (filterproduct), o que eu vou dar como padrão é o ProductsFilterModal."
export default ProductsFilterModal;

// Esta linha diz: "E também exporte o 'tipo' FilterStatus, para que outros arquivos saibam como usar o filtro."
export type { FilterStatus } from './ProductsFilterModal';